<template>
  <div>
    <Head title="Ranking Permohonan Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">Ranking Permohonan Beasiswa</h1>
    <div class="w-full mb-8 bg-white rounded-md shadow">
      <div class="w-full p-4 bg-gray-200">Filter</div>
      <div class="flex flex-wrap w-full p-6">
        <div class="w-full lg:w-3/12">Periode Beasiswa:</div>
        <v-select
          v-model="form.periode" :options="periodes" class="w-full lg:w-9/12" :reduce="periode => periode.id"
          label="nama" placeholder="Pilih Periode"
        />
        <div class="w-full mt-2 lg:w-3/12">Jenis Perguruan Tinggi:</div>
        <v-select
          v-model="form.status_university" :options="universityTypes" class="w-full mt-2 lg:w-9/12" :reduce="type => type.id"
          label="nama" placeholder="Pilih Jenis Perguruan Tinggi"
        />
        <div class="w-full mt-2 lg:w-3/12">Universitas:</div>
        <v-select
          v-model="form.university" :options="universities" class="w-full mt-2 lg:w-9/12"
          :reduce="university => university.id" label="nama" placeholder="Pilih Universitas"
        />
        <div class="w-full mt-2 lg:w-3/12">Prodi:</div>
        <v-select
          v-model="form.prodi" :options="prodis" class="w-full mt-2 lg:w-9/12" :reduce="prodi => prodi.id"
          label="nama" placeholder="Pilih Prodi"
        />
        <div class="w-full mt-2 lg:w-3/12">Status Permohonan:</div>
        <v-select
          v-model="form.status" :options="status_permohonans" class="w-full mt-2 lg:w-9/12" :reduce="status_permohonan => status_permohonan.id"
          label="nama" placeholder="Pilih Status Permohonan"
        />
        <div class="w-full mt-2 lg:w-3/12">Nama/ NIM Mahasiswa:</div>
        <text-input v-model="form.search" class="w-full mt-2 lg:w-9/12" placeholder="Search..." autofocus />
      </div>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <div class="flex justify-end w-full p-4 bg-gray-100">
        <a :href="downloadUrl" target="_blank" class="btn-green"><font-awesome-icon
          icon="fas fa-file-excel"
          class="mr-2"
        />
          Download Ranking</a>
        <a
          type="button" class="mx-2 btn-indigo" @click.prevent="downloadSK"
        ><font-awesome-icon
          icon="fas fa-file-excel"
          class="mr-2"
        /> Download SK </a>
      </div>
      <table class="w-full whitespace-nowrap ">
        <thead>
          <tr class="font-bold text-left">
            <th class="items-center p-4 text-center border-t border-l " rowspan="3">No</th>
            <th class="p-4 border-t border-l " rowspan="3">Nama</th>
            <th class="p-4 border-t border-l " rowspan="3">NIM</th>
            <th class="p-4 border-t border-l " rowspan="3">NIK</th>
            <th class="p-4 border-t border-l " rowspan="3">Perguruan Tinggi</th>
            <th class="p-4 border-t border-l " rowspan="3">Program Studi</th>
            <th class="w-full p-4 text-center border-t border-l " colspan="4">Perguruan Tinggi</th>
            <th class="w-full p-4 text-center border-t border-l " colspan="2">Status Ekonomi</th>
            <th class="w-full p-4 text-center border-t border-l " colspan="3">Prestasi</th>
            <th class="p-4 border-t border-l " rowspan="3">Jumlah</th>
            <th class="p-4 border-t border-l " rowspan="3">Keterangan</th>
            <th class="p-4 border-t border-l " rowspan="3">-</th>
          </tr>
          <tr class="font-bold text-left">
            <th class="w-full p-4 text-center border-t border-l">PTN</th>
            <th class="w-full p-4 text-center border-t border-l">PTKL</th>
            <th class="w-full p-4 text-center border-t border-l">PTN<br />Lokal</th>
            <th class="w-full p-4 text-center border-t border-l">PTS</th>
            <th class="w-full p-4 text-center border-t border-l">Tidak<br />Mampu</th>
            <th class="w-full p-4 text-center border-t border-l">Mampu</th>
            <th class="w-full p-4 text-center border-t border-l">Inter<br />nasional</th>
            <th class="w-full p-4 text-center border-t border-l">Nasional</th>
            <th class="w-full p-4 text-center border-t border-l">Provinsi</th>
          </tr>
          <tr class="font-bold text-left">
            <th class="w-full p-4 text-center border-t border-l">4</th>
            <th class="w-full p-4 text-center border-t border-l">3</th>
            <th class="w-full p-4 text-center border-t border-l">3</th>
            <th class="w-full p-4 text-center border-t border-l">1</th>
            <th class="w-full p-4 text-center border-t border-l">3</th>
            <th class="w-full p-4 text-center border-t border-l">1</th>
            <th class="w-full p-4 text-center border-t border-l">3</th>
            <th class="w-full p-4 text-center border-t border-l">2</th>
            <th class="w-full p-4 text-center border-t border-l">1</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(application, index) in applications.data" :key="application.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="p-4 text-center border-t border-l ">{{ index+1 }}</td>
            <td
              class="p-4 border-t border-l"
              :class="{ 'text-green-700': application.status == 5 , 'text-red-700': application.status == 6}"
            >
              {{ application.nama }}
            </td>
            <td class="w-full p-4 border-t border-l">{{ application.nim }}</td>
            <td class="w-full p-4 border-t border-l">{{ application.nik }}</td>
            <td class="w-full p-4 border-t border-l">{{ application.nama_universitas }}</td>
            <td class="w-full p-4 border-t border-l">{{ application.nama_prodi }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.ptn }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.ptkl }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.ptnl }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.pts }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.tidak_mampu }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.mampu }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.prestasi_internasional }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.prestasi_nasional }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.prestasi_provinsi }}</td>
            <td class="w-full p-4 text-center border-t border-l">{{ application.jumlah }}</td>
            <td class="p-4 border-t border-l">{{ application.keterangan }}</td>

            <td class="w-px border-t border-l">
              <Link class="flex items-center px-4" :href="`/verified-scholar-applications/${application.id}`" tabindex="-1">
                <font-awesome-icon icon="fas fa-chevron-right" class="block w-6 h-6 mr-2" />
              </Link>
            </td>
          </tr>
          <tr v-if="applications.data.length === 0">
            <td class="px-6 py-4 border-t border-l" :colspan="can('write permohonan beasiswa') ? 13 : 12">
              Tidak ada data permohonan
              beasiswa.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="applications.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '../../Shared/TextInput.vue'

export default {
  components: {
    Head,
    Link,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    applications: Object,
    filters: Object,
    universities: Array,
    prodis: Array,
    periodes: Array,
  },

  data() {
    return {
      form: {
        university: parseInt(this.filters.university) || null,
        prodi: parseInt(this.filters.prodi) || null,
        periode: parseInt(this.filters.periode) || null,
        status: parseInt(this.filters.status) || null,
        search: this.filters.search,
        jenis: parseInt(this.filters.jenis) || null,
      },
      universityTypes: [
        { id: 'PTN', nama: 'PTN' },
        { id: 'PTNL', nama: 'PTN Lokal' },
        { id: 'PTKL', nama: 'PTKL' },
        { id: 'PTS', nama: 'PTS' },
      ],
      status_permohonans: [
        { id: 4, nama: 'Belum Diputuskan' },
        { id: 5, nama: 'Disetujui' },
        { id: 6, nama: 'Ditolak' },
      ],
    }
  },

  computed: {
    downloadUrl() {
      let query = pickBy(this.form)
      return this.route('scholar-application-rank.download', Object.keys(query).length ? query : {})
    },
    downloadResultUrl() {
      let query = pickBy(this.form)
      return this.route('scholar-application-final.download', Object.keys(query).length ? query : {})
    },
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('verify-scholar-applications.rank')
          , Object.keys(query).length ? query : { remember: 'forget' }
          , {
            preserveState: true,
            preserveScroll: true,
          })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

    async downloadSK() {
      const { value: catatan } = await this.$swal.fire({
        title: 'Download SK Hasil Seleksi',
        input: 'number',
        inputLabel: 'Masukan tahun Anggaran',
        inputValue: new Date().getFullYear()+1,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        inputValidator: (value) => {
          if (!value) {
            return 'Tahun Anggaran harus diisi!'
          }
        },
      })

      if (catatan) {
        const url = new URL(this.downloadResultUrl)
        url.searchParams.append('tahun_anggaran', catatan)
        window.location.href = url.toString()
      }
    },
  },
}
</script>
